// extracted by mini-css-extract-plugin
export default {"JourneySettingsPage":"JourneySettingsPage_JourneySettingsPage__oJfFK","JourneySettingsPage__content":"JourneySettingsPage_JourneySettingsPage__content__sJ5zp"};